// extracted by mini-css-extract-plugin
export default {"authorsResults":"styles_authorsResults__wwqvt"};